import { Injectable } from '@angular/core';

import { LiteratureDataService } from '@literature/services/literature-data.service';
import { SegmentService } from '@services/segment.service';
import {
  LiteratureData,
  LiteratureDocument,
  LiteratureDocumentData,
  SegmentId,
  LiteratureContentDocument,
} from '@types';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeaturedLiteratureService {
  literatureContentDocuments: LiteratureContentDocument[];
  constructor(
    private literatureDataService: LiteratureDataService,
    protected segmentService: SegmentService
  ) {}

  populate(
    params: Map<string, string>,
    literatureContentDocument: LiteratureContentDocument[]
  ): Observable<LiteratureDocument[]> {
    return this.literatureDataService.loadData(params, false, true).pipe(
      map((data: LiteratureData) =>
        data?.document?.map((item) => this.modifyFeaturedData(item))
      ),
      map((data: LiteratureDocument[]) =>
        this.literatureDataService.getContentLiteratureDocumentsForDisplay(
          data,
          literatureContentDocument
        )
      ),
      shareReplay(1)
    );
  }

  modifyFeaturedData(data: LiteratureDocumentData): LiteratureDocument {
    const detailData = this.literatureDataService.literatureMapper(data);
    this.literatureDataService.mapLiteratureUrl(detailData);
    if (SegmentId.INVESTOR === this.segmentService.getCurrentSegmentId()) {
      detailData.isInvestor = true;
    }
    return detailData;
  }
}
